export default __webpack_public_path__ + "267a3e74b495e6d37d5e293ac2827f37.png";